import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-self-learn-sidebar',
  templateUrl: './self-learn-sidebar.component.html',
  styleUrls: ['./self-learn-sidebar.component.css']
})
export class SelfLearnSidebarComponent implements OnInit {

  mobileMenuOpenStatus:boolean = false;

  ngAfterViewInit() {
    // $('.SLV2-LHS-mob-burger-menu').click(function () {
    //   $('.SLV2-LHS-section').toggleClass('opened');
    // });
    // $('.SLV2-LHS-section + .m-overlay').click(function () {
    //   $('.SLV2-LHS-section').removeClass('opened');
    // });
  }

  constructor() { }

  ngOnInit(): void {
  }

  showMyProfile(){
    
  }

  mobileMenuClick(){
    this.mobileMenuOpenStatus = !this.mobileMenuOpenStatus;
  }

}
